import { Add, GridView } from "@mui/icons-material";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { useLocation } from "react-router-dom";
import { Outlet, Link } from "react-router-dom";

const Adders = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span>{path}</span>
                </div>

                <Link to="/dashboard/adders/create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default Adders;
